(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function showToast(message, isError) {
    var toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.toggle('cart-toast--error', Boolean(isError));
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
        return cart;
      });
  }

  function addToCart(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw error;
        });
      }
      return response.json();
    });
  }

  function initHeroCarousels() {
    document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
      var track     = carousel.querySelector('[data-hero-track]');
      var slides    = Array.prototype.slice.call(carousel.querySelectorAll('[data-hero-slide]'));
      var dots      = Array.prototype.slice.call(carousel.querySelectorAll('[data-hero-dot]'));
      var prevBtn   = carousel.querySelector('[data-hero-prev]');
      var nextBtn   = carousel.querySelector('[data-hero-next]');

      if (!track || slides.length === 0) return;

      var active     = 0;
      var timer      = null;
      var paused     = false;
      var touchStart = null;

      /* Read autoplay speed from section setting via data-attribute (ms) */
      var speedAttr  = carousel.getAttribute('data-autoplay-speed');
      var interval   = speedAttr ? (parseInt(speedAttr, 10) * 1000) : 4000;

      /* ── Move the track ── */
      function goTo(index) {
        active = (index + slides.length) % slides.length;

        /* Slide the track */
        track.style.transform = 'translateX(-' + (active * 100) + '%)';

        /* Update aria on slides */
        slides.forEach(function (slide, i) {
          var on = i === active;
          slide.classList.toggle('is-active', on);
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        });

        /* Update dots */
        dots.forEach(function (dot, i) {
          var on = i === active;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      /* ── Autoplay ── */
      function stopAuto() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function startAuto() {
        stopAuto();
        if (slides.length < 2 || paused) return;
        timer = window.setInterval(function () {
          goTo(active + 1);
        }, interval);
      }

      /* ── Controls ── */
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(active - 1);
          startAuto();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(active + 1);
          startAuto();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(Number(dot.getAttribute('data-hero-dot')));
          startAuto();
        });
      });

      /* ── Pause on hover (desktop) ── */
      carousel.addEventListener('mouseenter', function () {
        paused = true;
        stopAuto();
      });
      carousel.addEventListener('mouseleave', function () {
        paused = false;
        startAuto();
      });

      /* ── Swipe gestures (mobile) — 50px threshold ── */
      carousel.addEventListener('touchstart', function (e) {
        touchStart = e.touches[0].clientX;
        paused = true;
        stopAuto();
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        if (touchStart === null) return;
        var delta = e.changedTouches[0].clientX - touchStart;
        if (Math.abs(delta) >= 50) {
          goTo(delta < 0 ? active + 1 : active - 1);
        }
        touchStart = null;
        paused = false;
        startAuto();
      }, { passive: true });

      /* ── Init ── */
      goTo(0);
      startAuto();
    });
  }

  function initDesktopDropdowns() {
    document.querySelectorAll('.nav-dropdown').forEach(function (item) {
      var closeTimer = null;

      function open() {
        if (closeTimer) window.clearTimeout(closeTimer);
        item.classList.add('is-open');
      }

      function close() {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          item.classList.remove('is-open');
        }, 150);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) close();
      });
    });
  }

  function initMobileNav() {
    var hamburger = document.getElementById('hamburgerBtn');
    var drawer    = document.getElementById('mobileNavDrawer');
    var overlay   = document.getElementById('mobileNavOverlay');
    var closeBtn  = document.getElementById('mobileNavClose');

    if (!hamburger || !drawer || !overlay || !closeBtn) return;

    function openNav() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', openNav);
    closeBtn.addEventListener('click', closeNav);
    overlay.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    function setToggleState(button, open) {
      button.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeLevelTwoWithin(container) {
      container.querySelectorAll('[data-mobile-toggle="level2"]').forEach(function (button) {
        setToggleState(button, false);
      });
      container.querySelectorAll('.mobile-nav-sub--level2').forEach(function (sub) {
        sub.classList.remove('is-open');
      });
    }

    drawer.querySelectorAll('.mobile-nav-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var level = this.getAttribute('data-mobile-toggle');
        var sub = this.nextElementSibling;
        var wasOpen = this.classList.contains('is-open');
        if (!sub || !sub.classList.contains('mobile-nav-sub')) return;

        if (level === 'level1') {
          drawer.querySelectorAll('[data-mobile-toggle="level1"]').forEach(function (button) {
            var buttonSub = button.nextElementSibling;
            setToggleState(button, false);
            if (buttonSub) {
              buttonSub.classList.remove('is-open');
              closeLevelTwoWithin(buttonSub);
            }
          });

          if (!wasOpen) {
            setToggleState(this, true);
            sub.classList.add('is-open');
          }
          return;
        }

        setToggleState(this, !wasOpen);
        sub.classList.toggle('is-open', !wasOpen);
      });
    });
  }

  function initCartButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.js-add-to-cart');
      if (!button) return;
      event.preventDefault();

      var variantId = button.getAttribute('data-variant-id');
      var quantity = Number(button.getAttribute('data-quantity') || 1);
      if (!variantId || button.disabled) return;

      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';

      addToCart({ id: Number(variantId), quantity: quantity })
        .then(refreshCartCount)
        .then(function () {
          showToast('Added to cart');
        })
        .catch(function (error) {
          showToast(error && error.description ? error.description : 'Unable to add item. Please try again.', true);
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = originalText;
        });
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.js-product-form');
      if (!form) return;
      event.preventDefault();

      var submit = form.querySelector('.js-product-submit');
      if (submit && submit.disabled) return;

      var originalText = submit ? submit.textContent : '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }
          return response.json();
        })
        .then(refreshCartCount)
        .then(function () {
          showToast('Added to cart');
        })
        .catch(function (error) {
          showToast(error && error.description ? error.description : 'Unable to add item. Please try again.', true);
        })
        .finally(function () {
          if (submit) {
            submit.disabled = false;
            submit.textContent = originalText;
          }
        });
    });
  }

  function initProductForms() {
    document.querySelectorAll('.js-product-form').forEach(function (form) {
      var optionSelects = Array.prototype.slice.call(form.querySelectorAll('.js-variant-option'));
      var variantSelect = form.querySelector('.js-variant-id');
      var submit = form.querySelector('.js-product-submit');
      var info = form.closest('.product-info');
      var price = info ? info.querySelector('.js-product-price') : null;
      var compare = info ? info.querySelector('.js-product-compare') : null;

      if (!variantSelect) return;

      function selectedOptionValues() {
        return optionSelects.map(function (select) {
          return select.value;
        });
      }

      function findMatchingVariant() {
        if (optionSelects.length === 0) {
          return variantSelect.options[variantSelect.selectedIndex];
        }

        var selected = selectedOptionValues();
        return Array.prototype.slice.call(variantSelect.options).find(function (option) {
          return selected.every(function (value, index) {
            return option.getAttribute('data-option' + (index + 1)) === value;
          });
        });
      }

      function updateVariant() {
        var match = findMatchingVariant();
        if (!match) return;

        variantSelect.value = match.value;
        if (price) price.textContent = match.getAttribute('data-price') || '';

        var compareValue = match.getAttribute('data-compare') || '';
        if (compare) {
          compare.textContent = compareValue;
          compare.hidden = !compareValue;
        }

        var available = match.getAttribute('data-available') === 'true';
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? 'Add to Cart' : 'Sold out';
        }
      }

      optionSelects.forEach(function (select) {
        select.addEventListener('change', updateVariant);
      });

      updateVariant();
    });
  }

  function initProductGallery() {
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;

      var gallery = thumb.closest('[data-product-gallery]');
      var main = gallery ? gallery.querySelector('[data-gallery-main]') : null;
      if (!main) return;

      main.src = thumb.getAttribute('data-full-src');
      main.alt = thumb.getAttribute('data-full-alt') || main.alt;
      main.animate(
  [
    { opacity: 0.75, transform: 'scale(0.98)' },
    { opacity: 1, transform: 'scale(1)' }
  ],
  {
    duration: 320,
    easing: 'ease'
  }
);

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
        button.classList.toggle('is-active', button === thumb);
      });
    });
  }

  function initQuantityControls() {
    document.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-quantity-minus]');
      var plus = event.target.closest('[data-quantity-plus]');
      if (!minus && !plus) return;

      var control = event.target.closest('.quantity-control');
      var input = control ? control.querySelector('input[name="quantity"]') : null;
      if (!input) return;

      var value = Math.max(1, Number(input.value || 1));
      input.value = plus ? value + 1 : Math.max(1, value - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  ready(function () {
    initHeroCarousels();
    initDesktopDropdowns();
    initMobileNav();
    initCartButtons();
    initProductForms();
    initProductGallery();
    initQuantityControls();
    initSearch();
    refreshCartCount().catch(function () {});
  });
})();

/* ============================================================
   SEARCH — PREDICTIVE LIVE SEARCH
   ============================================================ */
(function () {
  /* ── Element refs ── */
  var toggleBtn        = document.getElementById('searchToggleBtn');
  var barDesktop       = document.getElementById('searchBarDesktop');
  var inputDesktop     = document.getElementById('searchInputDesktop');
  var closeDesktop     = document.getElementById('searchCloseDesktop');
  var formDesktop      = document.getElementById('searchFormDesktop');
  var resultsDesktop   = document.getElementById('searchResultsDesktop');

  var overlayMobile    = document.getElementById('searchOverlayMobile');
  var backdropMobile   = document.getElementById('searchBackdropMobile');
  var inputMobile      = document.getElementById('searchInputMobile');
  var closeMobile      = document.getElementById('searchCloseMobile');
  var formMobile       = document.getElementById('searchFormMobile');
  var resultsMobile    = document.getElementById('searchResultsMobile');

  if (!toggleBtn) return; /* Search not present on this page */

  var isMobile        = function () { return window.innerWidth <= 768; };
  var debounceTimer   = null;
  var currentIndex    = -1;
  var currentResults  = [];

  /* ── Money formatter ── */
  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    var str = String(amount);
    /* Indian comma format: last 3 then every 2 */
    if (str.length > 3) {
      var last3 = str.slice(-3);
      var rest  = str.slice(0, -3);
      rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      str = rest + ',' + last3;
    }
    return '\u20B9' + str; /* ₹ */
  }

  /* ── Open / close ── */
  function openSearch() {
    if (isMobile()) {
      overlayMobile.classList.add('is-open');
      overlayMobile.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (inputMobile) { inputMobile.value = ''; inputMobile.focus(); }
    } else {
      barDesktop.classList.add('is-open');
      barDesktop.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      if (inputDesktop) { inputDesktop.value = ''; inputDesktop.focus(); }
    }
    currentIndex = -1;
    currentResults = [];
  }

  function closeSearch() {
    /* Desktop */
    if (barDesktop) {
      barDesktop.classList.remove('is-open');
      barDesktop.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      if (inputDesktop) inputDesktop.value = '';
      hideResults(resultsDesktop);
    }
    /* Mobile */
    if (overlayMobile) {
      overlayMobile.classList.remove('is-open');
      overlayMobile.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (inputMobile) inputMobile.value = '';
      if (resultsMobile) resultsMobile.innerHTML = '';
    }
    currentIndex = -1;
    currentResults = [];
  }

  /* ── Results helpers ── */
  function hideResults(container) {
    if (!container) return;
    container.classList.remove('is-visible');
    container.innerHTML = '';
  }

  function renderResults(products, query, container, mobile) {
    if (!container) return;
    currentResults = products;
    currentIndex = -1;
    container.innerHTML = '';

    if (products.length === 0) {
      var msg = document.createElement('div');
      msg.className = 'search-no-results';
      msg.textContent = 'No products found for \u2018' + query + '\u2019';
      container.appendChild(msg);
      container.classList.add('is-visible');
      return;
    }

    products.forEach(function (product, idx) {
      var a = document.createElement('a');
      a.href = product.url;
      a.className = mobile ? 'search-result-item--mobile' : 'search-result-item';
      a.setAttribute('role', 'option');
      a.setAttribute('data-index', idx);

      /* Image */
      var imgEl;
      if (product.featured_image && product.featured_image.url) {
        imgEl = document.createElement('img');
        imgEl.src = product.featured_image.url;
        imgEl.alt = product.title;
        imgEl.width = mobile ? 56 : 48;
        imgEl.height = mobile ? 56 : 48;
        imgEl.className = mobile ? 'search-result-img--mobile' : 'search-result-img';
      } else {
        imgEl = document.createElement('div');
        imgEl.className = mobile ? 'search-result-img--mobile' : 'search-result-img';
      }

      /* Info */
      var info = document.createElement('div');
      info.className = 'search-result-info';

      var title = document.createElement('div');
      title.className = 'search-result-title';
      title.textContent = product.title;

      var price = document.createElement('div');
      price.className = 'search-result-price';
      var priceVal = product.price || (product.price_min);
      price.textContent = priceVal !== undefined ? formatMoney(priceVal) : '';

      info.appendChild(title);
      if (priceVal !== undefined) info.appendChild(price);
      a.appendChild(imgEl);
      a.appendChild(info);
      container.appendChild(a);
    });

    container.classList.add('is-visible');
  }

  /* ── Fetch suggestions ── */
  function fetchSuggestions(query, container, mobile) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6', {
      headers: { Accept: 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data.resources && data.resources.results &&
                      data.resources.results.products) || [];
      renderResults(products, query, container, mobile);
    })
    .catch(function () { hideResults(container); });
  }

  /* ── Input handler ── */
  function handleInput(query, container, mobile) {
    clearTimeout(debounceTimer);
    if (query.length < 2) { hideResults(container); return; }
    debounceTimer = setTimeout(function () {
      fetchSuggestions(query, container, mobile);
    }, 300);
  }

  /* ── Keyboard navigation (desktop) ── */
  function moveIndex(dir, container) {
    var items = container ? container.querySelectorAll('.search-result-item') : [];
    if (!items.length) return;
    items[currentIndex >= 0 ? currentIndex : 0] && items[currentIndex >= 0 ? currentIndex : 0].classList.remove('is-active');
    currentIndex = Math.max(0, Math.min(currentIndex + dir, items.length - 1));
    var active = items[currentIndex];
    if (active) {
      container.querySelectorAll('.search-result-item').forEach(function (el) { el.classList.remove('is-active'); });
      active.classList.add('is-active');
      active.scrollIntoView({ block: 'nearest' });
    }
  }

  /* ── Event wiring ── */
  toggleBtn.addEventListener('click', openSearch);
  if (closeDesktop) closeDesktop.addEventListener('click', closeSearch);
  if (closeMobile)  closeMobile.addEventListener('click', closeSearch);
  if (backdropMobile) backdropMobile.addEventListener('click', closeSearch);

  if (inputDesktop) {
    inputDesktop.addEventListener('input', function () {
      handleInput(this.value.trim(), resultsDesktop, false);
    });
    inputDesktop.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveIndex(1, resultsDesktop); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveIndex(-1, resultsDesktop); }
      else if (e.key === 'Enter' && currentIndex >= 0 && currentResults[currentIndex]) {
        e.preventDefault();
        window.location.href = currentResults[currentIndex].url;
      }
      else if (e.key === 'Escape') { closeSearch(); }
    });
  }

  if (inputMobile) {
    inputMobile.addEventListener('input', function () {
      handleInput(this.value.trim(), resultsMobile, true);
    });
    inputMobile.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSearch(); }
    });
  }

  /* Close desktop bar on outside click */
  document.addEventListener('click', function (e) {
    if (!barDesktop || !barDesktop.classList.contains('is-open')) return;
    if (!barDesktop.contains(e.target) && e.target !== toggleBtn && !toggleBtn.contains(e.target)) {
      closeSearch();
    }
  });

  /* Global Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

})();

/* ==========================================
   PREMIUM HEADER SCROLL
========================================== */

function initHeaderScroll() {

  const header = document.querySelector('.site-header');

  if (!header) return;

  function updateHeader() {

    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }

  }

  updateHeader();

  window.addEventListener('scroll', updateHeader);

}

document.addEventListener(
  'DOMContentLoaded',
  initHeaderScroll
);

/* ===== Premium Scroll Reveal ===== */
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll(
    '.featured-products, .category-grid-section, .reviews-section, .about-strip, .page-section, .collection-main__body, .product-main'
  );
  var cards = document.querySelectorAll('.product-card');

  sections.forEach(function (section) {
    section.classList.add('reveal-section');
  });

  cards.forEach(function (card) {
    card.classList.add('reveal-card');
  });

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (section) {
      section.classList.add('is-visible');
    });
    cards.forEach(function (card) {
      card.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.remove('is-visible');
      }
    });
  }, {
    threshold: 0.01,
    rootMargin: '0px 0px -15% 0px'
  });

  sections.forEach(function (section) {
    observer.observe(section);
  });

  cards.forEach(function (card) {
    observer.observe(card);
  });
});

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('template-index')) return;

    /* Show only once per browser session */
    if (sessionStorage.getItem('layaSplashShown')) {
      return;
    }

    sessionStorage.setItem('layaSplashShown', 'true');

    var splash = document.createElement('div');
    splash.className = 'laya-splash';
    splash.id = 'LayaSplash';
    splash.innerHTML = `
      <div class="laya-splash__panel" aria-label="Welcome screen">
        <span class="laya-splash__line laya-splash__line--1">Welcome</span>
        <span class="laya-splash__line laya-splash__line--2">to</span>
        <span class="laya-splash__line laya-splash__line--3">Laya's Little Shop</span>
      </div>
    `;

    document.body.appendChild(splash);
    document.body.classList.add('laya-splash-active');

    requestAnimationFrame(function () {
      splash.classList.add('is-visible');
    });

    window.setTimeout(function () {
      splash.classList.add('is-hiding');
      document.body.classList.remove('laya-splash-active');

      window.setTimeout(function () {
        splash.remove();
      }, 500);
    }, 2400);
  });
})();



